<ui-modal
  [title]="title | localization"
  [description]="destription | localization"
  titleAlign="center"
  [footer]="footerRef"
  (afterClose)="onCancel()"
  [maskClosable]="false"
  [mask]="true"
>
</ui-modal>

<ng-template #footerRef>
  <div class="flex flex-row gap-4">
    @if(buttons && buttons.length > 0){ @for(btn of buttons; track $index){
    <ui-button
      [type]="btn?.type ?? 'primary'"
      [color]="btn?.color ?? 'basic'"
      [block]="true"
      [disabled]="isConfirming"
      (click)="onConfirm(btn?.onClicked)"
      style="width: 100%"
    >
      {{ btn.title | localization }}
    </ui-button>
    } }@else{
    <ui-button
      type="secondary"
      [color]="buttonColor || 'basic'"
      [block]="true"
      [disabled]="isConfirming"
      (click)="onCancel()"
      style="width: 100%"
    >
      {{ 'base.no' | localization }}
    </ui-button>
    <ui-button
      type="primary"
      [color]="buttonColor || 'basic'"
      [block]="true"
      [loading]="isConfirming"
      (click)="onConfirm()"
      style="width: 100%"
    >
      {{ 'base.yes' | localization }}
    </ui-button>
    }
  </div>
</ng-template>
